import types from "actions/office_view/types";
import callTypes from "actions/call/types";
import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";
import { PhoneUtil } from "utils";

const newCall = (state, leg, call, user_id) => {
    call.status = "ringing";
    call.updated = Math.floor(Date.now() / 1000);
    call.isSystemCall = call.call_type === "click2dial" || call.call_type === "newlead" || call.call_type === "sequence" || call.call_type === "callback" || call.call_type === "task"
    const myleg = call.legs.find(l => (l.user_id === user_id && (!call.ringing_agent || l.channel_uuid)))
    call.display = true;
    // Need to check user_id not extension because the dialer can be used without an extension
    if (state.calls[call.uuid]) {
        if (call.company_destination && state.calls[call.uuid].start) {
            call.start = state.calls[call.uuid].start;
        } else {
            call.drift = state.calls[call.uuid].drift;
        }
    } else if (call.start) {
        call.drift = call.start - Math.floor(Date.now() / 1000)
    } else {
        call.start = Math.floor(Date.now() / 1000);
        call.drift = 0;
    }
    call.actionButtons = {
        hangup: false,
        vmDrop: false,
        transfer: false,
        hold: false,
        mute: false,
        answer: false,
    };

    if (call.call_type === "dialer") {
        if (myleg) {
            if (state.dialer?.loading) {
                delete state.dialer.loading
            }
            call.uuid = leg // hack
            // Need to replace current dialer call
            // Need to setup dialer_agent_uuid if not exists
            // Need to setup drift
            // Need to contact_id ?
            // Need to update state.extensions
            // Need to remove the notes and tags if exists
            if (state.dialer?.call_uuid !== call.uuid) {
                if (myleg.ext) {
                    if (state.extensions[myleg.ext]) {
                        // Check for dups
                        if (!state.calls[call.uuid]) {
                            state.extensions[myleg.ext] = state.extensions[myleg.ext].push(call.uuid)
                        }
                    } else {
                        state.extensions[myleg.ext] = [call.uuid]
                    }
                }
                if (state.dialer?.call_uuid) {
                    delete state.calls[state.dialer.call_uuid]
                    if (myleg.ext && state.extensions[myleg.ext]) {
                        state.extensions[myleg.ext] = state.extensions[myleg.ext].filter(uuid => uuid !== state.dialer.call_uuid)
                    }
                }
                if (state.dialer) {
                    delete state.dialer.ended_uuid
                    state.dialer.call_uuid = call.uuid;
                    state.dialer.agent_uuid = myleg.channel_uuid;
                    state.dialer.contact_id = call.legs.find(l => l.contact_id)?.contact_id;
                    if (call.campaign_id) {
                        state.dialer.campaign_id = call.campaign_id;
                    }
                } else {
                    state.dialer = {
                        call_uuid: call.uuid,
                        agent_uuid: myleg.channel_uuid,
                        contact_id: call.legs.find(l => l.contact_id)?.contact_id,
                        campaign_id: call.campaign_id,
                        status: "ongoing"
                    };
                }
            }
            state.calls[call.uuid] = {...call};
            return { ...state, dialer: { ...state.dialer }, calls: {...state.calls}}
        }
        const extLeg = call.legs.find(l => l?.extension)
        if (extLeg?.user_id && extLeg.user_id !== user_id) {
            state.extensions[extLeg.extension] = state.extensions[extLeg.extension]?.filter(c => state.calls[c]?.call_type !== 'dialer' || c === call.uuid)
            if (state.extensions[extLeg.extension]) {
                if (!state.extensions[extLeg.extension].includes(call.uuid)) {
                    state.extensions[extLeg.extension].push(call.uuid)
                }
            } else {
                state.extensions[extLeg.extension] = [call.uuid]
            }
            state.calls[call.uuid] = { ...call };
        }
        return { ...state, extensions: { ...state.extensions }, calls: { ...state.calls } };
    }
    if (myleg && myleg.extension && call.call_type !== 'dialer') {
        if (!state.currentCall || (call.direction === 'outbound' && !call.ringing_agent && (call.call_type !== 'newlead' && call.call_type !== 'callback' && call.call_type !== 'sequence' && call.call_type !== 'task')) || (call.direction === 'internal' && call.uuid === myleg.channel_uuid)) {
            const leg = PhoneUtil.contactLeg(call, state.creds.extension)
            state.currentCall = call.uuid
            state.contact_lookup = leg //sets CNAM / user / contact or account  call header.
            state.currentCallPhoneNumber = leg?.phone
            state.callState = call.status
        } else if (state.currentCall === call.uuid) {
            state.callState = call.status
        }
    }

    //TODO: Potential for threeway, or warm transers else do bottom code block, lines 49-60
    //if (call.call_type === 'threeway' || call.call_type === 'warm') { set = false}
    if (call.direction === 'outbound') {
        // Newlead and callbacks can have multiple users with ringall
        if (call.call_type === 'newlead' || call.call_type === 'callback') {
            call.legs.forEach(l => {
                if (l.extension) {
                    if (state.extensions[l?.extension]) {
                        if (! state.extensions[l?.extension].find(c => c === call.uuid)) {
                            state.extensions[l.extension].push(call.uuid)
                        }
                    } else {
                        state.extensions[l.extension] = [call.uuid];
                    }
                }
            });
        } else {
            const userLeg = call.legs.find(l => l.extension);
            if (userLeg) {
                if (state.extensions[userLeg?.extension]) {
                    //if call extension exists
                    if (! state.extensions[userLeg?.extension].find(c => c === call.uuid)) {
                        state.extensions[userLeg.extension].push(call.uuid)
                    }
                } else {
                    //if extension does not exist
                    state.extensions[userLeg.extension] = [call.uuid];
                }
            }
        }
    } else if (call.direction === 'internal') {
        call.legs.forEach((leg) => {
            if(leg?.extension){
                if (!call.ringing_agent || leg.channel_uuid) {
                    const uniqueExtension = state.extensions[leg.extension]?.find((extUUID) => extUUID === call.uuid);
                    if(!!!uniqueExtension){
                        if(state.extensions[leg.extension]){
                            //if call extension exists
                            state.extensions[leg.extension].push(call.uuid)
                        } else {
                            //if extension does not exist
                            state.extensions[leg.extension] = [call.uuid];
                        }
                    }
                }
            } 
        })
    } else {
        const eventLeg = call.legs.find(l => l.channel_uuid === leg);
        if(eventLeg?.extension){
            if (state.extensions[eventLeg.extension]) {
                //if call extension exists
                state.extensions[eventLeg.extension].push(call.uuid)
            } else {
                //if extension does not exist
                state.extensions[eventLeg.extension] = [call.uuid];
            }
        }
    }
    state.calls[call.uuid] = call
    return { ...state, extensions: { ...state.extensions }, calls: { ...state.calls }, dialer: { ...state.dialer }} ;
}

const connectedCall = (state, leg, call) => {
    call.status = "active";
    call.updated = Math.floor(Date.now() / 1000);
    if (state.calls[call.uuid]) {
        //if WS is avalible update
        state.calls[call.uuid].connected = call.connected;
        state.calls[call.uuid].status = "active";
    } else if (state.calls['_' + call.sip_call_id]) {
        //if WEBRTC is avalible update
        state.calls[call.uuid] = call;
        delete state.calls['_' + call.sip_call_id]
        if (state.currentCall === '_' + call.sip_call_id) {
            state.currentCall = call.uuid;
        }
        const idx = state.extensions[state.creds.extension].indexOf('_' + call.sip_call_id)
        if (idx !== -1) {
            state.extensions[state.creds.extension][idx] = call.uuid
        }
    } else {
        //set WS message
        state.calls[call.uuid] = call;
    }

    if (state.calls[call.uuid]?.company_destination) {
        if (state.extensions[state.calls[call.uuid].company_destination]) {
            state.extensions[state.calls[call.uuid].company_destination] = state.extensions[state.calls[call.uuid].company_destination]?.filter(c => c !== call.uuid)
        }
        delete state.calls[call.uuid].company_destination
    }
    
    state.calls[call.uuid].drift = call.connected - Math.floor(Date.now() / 1000);
    if (call.uuid === state?.currentCall?.uuid) {
        state.status = 'active';
    }
    if (call.direction !== 'internal' && call.legs.find(l => l.extension === state.creds.extension) && call?.connected) {
        const phone = PhoneUtil.removeCountryCode(call.legs.find(l => !l.user_id).phone)
        if (phone) {
            state.creds.launch_url?.forEach((url, index) => {
                const popurl = url.url.replace(/%%phone(_number)?%%/i, phone)
                setTimeout(() => window.open(popurl, '_blank', 'noopener,noreferrer'), index * 300);
            })
        }
    }
    return state;
};

const endCall = (state, legUUID, call, user_id) => {
    const leg = call.legs.find(l => l.channel_uuid === legUUID);
    call.updated = Math.floor(Date.now() / 1000);
    if(call.uuid === legUUID) {
        state.extensions[call.company_destination] = state.extensions[call.company_destination]?.filter(c => c !== call.uuid)
    }
    if (state.calls[call.uuid]) {
        state.calls[call.uuid].duration = call.duration || 0;
    }

    if (call.call_type === "dialer" && !call.legs.some(l => l.user_id === user_id)) {
        Object.keys(state.extensions).forEach(ext => {
            if (state.extensions[ext]?.includes(call.uuid)) {
                state.extensions[ext] = state.extensions[ext].filter(c => c !== call.uuid)
            }
        });
        delete state.calls[call.uuid];
        return { ...state, extensions: { ...state.extensions }, calls: { ...state.calls } };
    }

    const isOwnDialerCall = call.call_type === "dialer" && leg?.user_id === user_id;
    if (isOwnDialerCall && state.dialer?.call_uuid) {
        const dialerCall = state.calls[state.dialer.call_uuid];
        dialerCall.duration = call.duration || 0;
        dialerCall.status = 'hangup';
    }
    if (state.dialer && isOwnDialerCall) {
        delete state.dialer.call_uuid;
        delete state.dialer.agent_uuid;
        state.dialer.ended_uuid = call.uuid;
        if (state.dialer.status !== 'done') {
            state.dialer = { ...state.dialer, status: 'hangup' }
        }
        if (! state.currentCall || state.calls?.[state.currentCall]?.call_type === 'dialer' || state.calls?.[state.currentCall]?.call_type === "") {
            state.callState = 'idle';
        } 
    } else if(leg?.extension === state.creds.extension && state.currentCall === call.uuid) {
        const curLeg = state.calls[call.uuid]?.legs.find(l => l.extension === leg.extension)
        if (curLeg && curLeg.channel_uuid !== legUUID) {
            return state
        }
        state.extensions[leg.extension] = state.extensions[leg.extension]?.filter(c => c !== call.uuid)
        state.currentCall = null
        if (call.connected) {
            state.endedCalls[leg.extension] = { ...call };
            state.callState = 'hangup'
        } else {
            state.callState = 'idle'
            state.islookingupContact = false
            state.contact_lookup = null
        }
    } else if(leg?.extension) {
        state.extensions[leg.extension] = state.extensions[leg.extension]?.filter(c => c !== call.uuid)
    } else if (call.call_type === "dialer" && state.dialer) {
        const myExt = call.legs.find(l => l.user_id === user_id);
        if (myExt) {
            if (myExt.channel_uuid !== legUUID) {
                state.dialer.ended_uuid = legUUID;
                state.dialer.pbx = call.pbx
                delete state.dialer.call_uuid;
            } else {
                state.dialer.ended_uuid = call.legs.find(l => l.extension !== state.creds.extension)?.channel_uuid;
                state.dialer.pbx = call.pbx
                delete state.dialer?.call_uuid;
            }
            state.dialer = { ...state.dialer, status: "hangup" }
        }
    }
    return { ...state, endedCalls: { ...state.endedCalls}, extensions: { ...state.extensions }, calls: { ...state.calls }, dialer: { ...state.dialer } };
};

function officeViewReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, islookingupContact: true };
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            const { call_uuid, ...contact } = action.data 
            if (state.currentCall) {
                //Current call but no uuid happens when you add or update a contact during an ongoing call.
                if (!!call_uuid) {
                    const idx = state.calls[call_uuid].legs.findIndex(l => (l.contact_id === contact.contact_id || l.account_id===contact.account_id))
                    if (idx !== -1) {
                        const {channel_uuid, phone} = state.calls[call_uuid].legs[idx]
                        state.calls[call_uuid].legs[idx] = {channel_uuid, phone, ...contact}
                    } 
                    if (state.currentCall === call_uuid) {
                        state.contact_lookup = action.data
                    }
                } else {
                    state.contact_lookup = action.data
                }
            } else if (! state.currentCall) {
                state.contact_lookup = action.data
            }
            return { ...state, islookingupContact: false };
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, islookingupContact: false };

        case getNamedAction(ACTION_NAMES.DIALER_CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_REQUEST): {
            return { ...state, dialerContactLookup: { name: "Loading..." }, isLookingUpDialerContact: true };
        }
        case getNamedAction(ACTION_NAMES.DIALER_CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_SUCCESS): {
            const { call_uuid } = action.data;
            return { ...state, dialerContactLookup: !call_uuid || call_uuid === state.dialer?.call_uuid ? action.data : null, isLookingUpDialerContact: false };
        }
        case getNamedAction(ACTION_NAMES.DIALER_CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_FAILURE): {
            return { ...state, dialerContactLookup: null, isLookingUpDialerContact: false };
        }

        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, islookingupUser: true };
        
        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_SUCCESS):
            const { id, username } = action.data[0];
            state.contact_lookup = { name: username, user_id: id }
            return { ...state, islookingupUser: false };
        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, islookingupUser: false };

        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingOfficeView: true };
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_SUCCESS):
            return {
                ...state,
                isReadingOfficeView: false,
                numberOfConferenceRooms: action.data.conference_rooms,
                departments: action.data.departments,
                extensions: action.data.extensions,
                queues: action.data.queues
            };
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingOfficeView: false };

        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCalls: true };
        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCalls: false, calls: action.data };
        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCalls: false };

        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingRecentCalls: true };
        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingRecentCalls: false, recentCalls: action.data };
        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingRecentCalls: false };
        case getNamedAction(ACTION_NAMES.ACTIVE_CALLS, CRUD_ACTION_TYPES.READ_REQUEST): {
            return { ...state, isGettingActiveCalls: true }
        }
        case getNamedAction(ACTION_NAMES.ACTIVE_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS): {
            if (!(action.data.now > 0)) {
                action.data.now = Date.now()/ 1000;
            }
            const drift = parseInt(action.data.now - (Date.now()/ 1000))
            Object.values(action.data.calls || {})?.forEach(call => {
                if (state.calls[call.uuid] && state.calls[call.uuid].updated > action.data.now) {
                    call = state.calls[call.uuid]
                } else if(call.status === "ringing"){
                    call.display = true;
                }
                call.drift = drift;
                call.isSystemCall = call.call_type === "click2dial" || call.call_type === "newlead" || call.call_type === "sequence" || call.call_type === "callback" || call.call_type === "task";
                call.actionButtons = {
                    hangup: false,
                    vmDrop: false,
                    transfer: false,
                    hold: false,
                    mute: false,
                    answer: false,
                };
            });
            const currentCallUUID = state.currentCall || action?.data?.extensions?.[state.creds.extension].find(c => c.call_type !== 'dialer')?.[0]
            const userCall = (currentCallUUID && action.data?.extensions && action.data?.extensions[state.creds?.extension]?.length) ?
                action.data?.calls[currentCallUUID] : null; 
            let leg = PhoneUtil.contactLeg(userCall, state.creds.extension)
            if (! leg && userCall?.company_destination) {
                leg = { name: userCall.destination_name, extension: userCall.company_destination }
            }
            const activeCalls = action.data?.calls || {};
            return {
                ...state,
                isGettingActiveCalls: false,
                extensions: action.data?.extensions || {},
                calls: activeCalls,
                ...(action.data?.campaign_name ? (() => {
                    const dialerCall = Object.values(activeCalls).find(c => c.call_type === "dialer" && c.status && c.legs.find(l => l.extension === state.creds.extension));
                    if (!dialerCall) {
                        return {};
                    }
                    return {
                        dialer: {
                            ...(state.dialer || {}),
                            campaign_name: action.data.campaign_name,
                            campaign_id: dialerCall.campaign_id,
                            status: dialerCall.status,
                            call_uuid: dialerCall.uuid,
                            campaign_conversion: action.data?.campaign_conversion
                        }
                    };
                })() : {}),
                ...(userCall ? {
                    callState: userCall.status,
                    currentCall: userCall.uuid,
                    callDirection: userCall.direction,
                    contact_lookup: leg,
                    currentCallPhoneNumber: leg.phone || leg.extension
            }: {}) };
        }
        case getNamedAction(ACTION_NAMES.ACTIVE_CALLS, CRUD_ACTION_TYPES.READ_FAILURE): {
            return { ...state, isGettingActiveCalls: false };
        }
        case types.ASSIGN_INCOMING_CALL_TO_QUEUE:
            return {
                ...state,
                queues: action.queues,
                incomingCalls: action.incomingCalls
            }
        case types.ASSIGN_INCOMING_CALL_TO_DEPARTMENT_AGENT:
            return {
                ...state,
                extensions: action.extensions,
                incomingCalls: action.incomingCalls
            }
        case types.ASSIGN_QUEUED_CALL_TO_DEPARTMENT_AGENT:
            return {
                ...state,
                extensions: action.extensions,
                queues: action.queues
            }

        case types.CALL_REQUEST:
            return { ...state, isCalling: true }
        case types.CALL_SUCCESS:
            return {
                ...state,
                incomingCalls: action.incomingCalls,
                callerInActionsView: action.contact || {},
                isActiveCall: true,
                actionsViewVisible: true,
                isCalling: true
            };
        case types.CALL_FAILURE:
            return { ...state, isCalling: false }

        case types.CLICK_RECENT_CALL:
            return {
                ...state,
                callerInActionsView: action.contact,
                actionsViewVisible: true,
                isActiveCall: false
            }

        case types.CLOSE_ACTIONS_VIEW:
            return { ...state, actionsViewVisible: false }

        case types.CLICK_ACTIVE_CALLER:
            return {
                ...state,
                callerInActionsView: action.contact,
                isActiveCall: true,
                actionsViewVisible: true
            }

        case types.REORDER_CALL_QUEUES:
            return {
                ...state,
                queues: action.queues
            }

        case types.HANGUP:
            return {
                ...state,
                isActiveCall: false,
                actionsViewVisible: false,
                callerInActionsView: null
            }
        case types.CHANGE_TEAMS_TAB:
            return {
                ...state,
                selectedTeamsTab: action.teamsTab
            }
        case callTypes.QUEUE:
            //only for parking lots & conference rooms
            const current = Math.floor((new Date()).getTime() / 1000)
            action.call.start = current
            if (action.call.company_destination.substr(0,4) === 'park' || action.call.company_destination.substr(0,1) === '7') {
                action.call.connected = current
            } 
            //Adds to company destinations
            const userLeg = action.call.legs.find(l => (l.user_id)); 

            if (state.extensions[action.call.company_destination]) {
                state.extensions[action.call.company_destination].push(action.call.uuid)
                if (action.call.company_destination.substr(0,1) === '7') {
                    //Add to Team View
                    if(userLeg){
                        if (state.extensions[userLeg.extension]) {
                            state.extensions[userLeg.extension].push(action.call.uuid)
                        } else {
                            state.extensions[userLeg.extension] = [action.call.uuid]
                        }
                    } 
                } 
            } else {
                if (state.extensions[action.call.company_destination]) {
                    state.extensions[action.call.company_destination].push(action.call.uuid)
                } else {
                    state.extensions[action.call.company_destination] = [action.call.uuid]
                }
                //Add to Team View
                if(userLeg){
                    if (state.extensions[userLeg.extension]) {
                        state.extensions[userLeg.extension].push(action.call.uuid)
                    } else {
                        state.extensions[userLeg.extension] = [action.call.uuid]
                    }
                } 
            }

            let currentCall;
            if (!state.calls[action.call.uuid]) {
                currentCall = {
                    ...action.call,
                    ...({
                        //dialing into a conference room
                        actionButtons: {
                            hangup: false,
                            vmDrop: false,
                            transfer: false,
                            hold: false,
                            mute: false,
                            answer: false,
                        },
                        status: "active"
                    }),    
                }
            } else {
                currentCall = {
                    ...state.calls[action.call.uuid], 
                    start: action.call.start, 
                    connected: action.call.connected, 
                    company_destination: action.call.company_destination,           
                }
            }

            if (action.call.company_destination.substr(0,1) === "7" && action.call.direction === "internal" && state.creds.extension && action.call.legs.find(l => l.extension === state.creds.extension)) {
                //dialing into a conference room
                state.currentCall = action.call.uuid
                state.callState = "active"
                state.contact_lookup = { name: action.call.destination_name } //, user_id: id 
                state.callDirection = action.call.direction
                state.currentCallPhoneNumber = action.call.company_destination
            }

            state.calls[action.call.uuid] = currentCall
            return { ...state, extensions: {...state.extensions}, calls: { ...state.calls } }
        case callTypes.QUEUE_END:
            state.extensions[action.call.company_destination] = state.extensions[action.call.company_destination]?.filter(uuid => uuid !== action.call.uuid)
            return {...state, extensions: {...state.extensions}, calls: { ...state.calls } }
        case callTypes.NEW_CALL:
            return newCall({ ...state }, action.leg, action.call, action.user_id)
        case callTypes.END_CALL:
            return endCall({ ...state }, action.leg, action.call, action.user_id)
        case callTypes.CONNECT_CALL:
            return connectedCall({ ...state }, action.leg, action.call)
        case callTypes.PRESSED:
            if (state.calls[action.call.uuid]) {
                const call = action.call;
                call.updated = Math.floor(Date.now() / 1000);
                state.calls[action.call.uuid] = {
                    ...state.calls[action.call.uuid],
                    ...action.call,
                    isSystemCall: call.call_type === "click2dial" || call.call_type === "newlead" || call.call_type === "sequence" || call.call_type === "callback" || call.call_type === "task",
                    press1: true
                }
            }
            return { ...state, calls: { ...state.calls } };
        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCreds: true };
        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCreds: false, creds: (action.data?.extension || action.data?.lead_connect) ? action.data : {}};
        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCreds: false, creds: {} };

        case 'RINGING_CALL':
            return { ...state, callState: 'ringing' };
        case 'ACTIVE_CALL':
            return { ...state, callState: 'active' };
        case 'IDLE_CALL':
            return { ...state, callState: 'idle' };
        case 'HANGUP_CALL':
            return { ...state, callState: 'hangup', currentCall: null, callDirection: null };
        case 'IGNORE_CALL':
            return { ...state, callState: 'idle', currentCall: null, callDirection: null };
        case 'CALL_DIRECTION':
            return { ...state, callDirection: action.direction };
        case 'CURRENT_CALL':
            return { ...state, currentCall: action.uuid, callState: state.calls[action.uuid]?.status };
        case 'CONTACT_LOOKUP':
            let lookup;
            if(state.calls[action.uuid]?.company_destination?.substr(0,1) === "7"){
                //conference room
                lookup = { name: state.calls[action.uuid].destination_name }
            } else {
                //will find contact/account/user for call
                lookup = PhoneUtil.contactLeg(state.calls[action.uuid], state.creds.extension)
            }
            return { ...state, contact_lookup: lookup };
        case 'CALL_DURATION':
            return { ...state, duration: action.duration };
        case 'CALL_ACTION_BUTTONS':
            if(action.call && state.calls[action.call]){
                state.calls[action.call].actionButtons = { ...state.calls[action.call].actionButtons, ...action.actionButton }
            }
            return { ...state, calls: { ...state.calls }};
        case 'CALL_RECORDING':
            const recordings = action.callRecordings;
            for (const key in recordings) {
                if (state.calls.hasOwnProperty(recordings[key].call_uuid)) {
                    state.calls[recordings[key].call_uuid].callRecording = recordings[key]
                }
                Object.keys(state.endedCalls).forEach(ext => {
                    if (state.endedCalls[ext]?.uuid === recordings[key].call_uuid) {
                        state.endedCalls[ext].callRecording = recordings[key];
                    }
                })
            }  
            return { ...state, calls: { ...state.calls }, endedCalls: { ...state.endedCalls } };
        case 'CALL_CURRENT_NUMBER':
            return { ...state, currentCallPhoneNumber: action.currentCallPhoneNumber };
        case 'CALL_CURRENT_TICKER':
            return { ...state, currentCallTicker: action.reset ? 0 : Math.floor((new Date()).getTime() / 1000) };
        case 'SET_SELECTED_TAB':                            
            return { ...state, selectedTab: action.selectedTab };
        case 'CHANGE_RESULT':
            return { ...state, calls: {...state.calls, [action.call]: {...state.calls[action.call], user_result: action.result}} };
        case 'CHANGE_NOTES':
            return { ...state, calls: {...state.calls, [action.call]: {...state.calls[action.call], notes: action.notes}} };
        case 'REMOVE_ENDED_CALL':
            state.endedCalls[action.extension] = null
            return { ...state  };
        case 'CLOSE_CALL_NOTIFICATIONS': 
            const userPhoneCreds = state.creds.extension;
            const calls = state.calls;
            if(action.call && state.calls[action.call]){
                state.calls[action.call].display = false;
                state.calls[action.call].updated = Math.floor(Date.now() / 1000);
            } else if(Object.keys(state.extensions).length !== 0) {
                state.extensions[userPhoneCreds]?.forEach(uuid => {
                    if (calls.hasOwnProperty(uuid)) {
                        state.calls[uuid].display = false;
                        state.calls[uuid].updated = Math.floor(Date.now() / 1000);
                    }
                })
            }
            return { ...state, calls: { ...state.calls }}

        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isHangingUp: true };
        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isHangingUp: false };
        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isHangingUp: false };

        case "REMOVE_VIEW_LOOKUP":
            return { ...state, islookingupContact: false, contact_lookup: null, currentCall: null };
        case "CONTACT_MERGE":
            /*
                action.calls is an object with the following structure:
                { [call_uuid]:[channel_uuid] }
            */
            for (const call_uuid in action.calls) {
                const channel_uuid = action.calls[call_uuid];

                if (call_uuid === state.currentCall) {
                    state.contact_lookup = action.contact
                }
                if (state.calls[call_uuid]) {
                    const idx = state.calls[call_uuid].legs.findIndex(l => l.channel_uuid === channel_uuid)
                    state.calls[call_uuid].legs[idx] = {
                        ...state.calls[call_uuid].legs[idx],
                        ...action.contact
                    }
                }
            }
            return {...state};

        // Is setting pressing over kill? Should we set another variable like status = "pressing"? 
        case getNamedAction(ACTION_NAMES.PRESSED, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return setStatus(state, "pressing")
        case getNamedAction(ACTION_NAMES.PRESSED, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            if (state.dialer) {
                const call = { ...state.calls[state.dialer.call_uuid], ringing_agent: false, press1: false }
                state.calls = { ...state.calls }
                state.calls[state.dialer.call_uuid] = call
            }
            return { ...state };
        case getNamedAction(ACTION_NAMES.PRESSED, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return deleteStatus(state)
        case getNamedAction(ACTION_NAMES.DIALER_NEXT, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return setStatus(state, "loading")
        case getNamedAction(ACTION_NAMES.DIALER_NEXT, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            {
                const contact_id = action.data?.contact_id;
                return {
                    ...state,
                    dialer: {
                        ...(state.dialer || {}),
                        contact_id: contact_id || state.dialer?.contact_id,
                        redirect: true, 
                        campaign_id: action.data?.campaign_id,
                        campaign_name: action.data?.campaign_name,
                        campaign_conversion: action.data?.campaign_conversion,
                        loading_next: false,
                        ...(action.data.complete ? { status: "done" } : { status: "ongoing" })
                    }
                };
            }
        case getNamedAction(ACTION_NAMES.DIALER_NEXT, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return deleteStatus(state)
        case getNamedAction(ACTION_NAMES.DIALER_START, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return setStatus(state, "loading")
        case getNamedAction(ACTION_NAMES.DIALER_START, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, dialer: { ...state.dialer, status: "ongoing", contact_id: action.data.contact_id, redirect: true, campaign_id: action.data.campaign_id, campaign_name: action.data.campaign_name, campaign_conversion: action.data?.campaign_conversion } };
        case getNamedAction(ACTION_NAMES.DIALER_START, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return deleteStatus(state)
        case getNamedAction(ACTION_NAMES.DIALER_END, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isSavingDialerResults: true };
        case getNamedAction(ACTION_NAMES.DIALER_END, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            const { dialer, ...rest } = state;
            return { ...rest, isSavingDialerResults: false, dialerContactLookup: null };
        case getNamedAction(ACTION_NAMES.DIALER_END, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isSavingDialerResults: false };
        case types.CLOSE_DIALER: {
            const { dialer, dialerContactLookup, ...rest } = state;
            return rest;
        }
        case types.IGNORE_DIALER_CALL: {
            return { ...state, dialer: { ...state.dialer, status: "hangup" } }
        }
        default:
            return state;
    }
}

function deleteStatus(state) {
    const { status, ...dialer } = state.dialer || {};
    return { ...state, dialer };
}

function setStatus(state, status) {
    if (status === "loading") {
        return { ...state, dialer: state.dialer ? { ...state.dialer, status, loading: true } : { status, loading: true } };
    }
    return { ...state, dialer: state.dialer ? { ...state.dialer, status } : { status } };
}

export default officeViewReducer;
